<template>
  <!-- @click="toUrl(items.path)" -->
    <div v-if="items && !items.hidden" class="box"  >
         <div  v-if="items.meta" @click="openMenu(items.path)" class="item"  :style="{ 'padding-left': indent.paddingLeft, 'background-color': items.path == nowPath ? 'rgba(255, 255, 255, .2)' : '' }">
          <svg-icon :iconClass="items.meta.icon" class="svg-icon" ></svg-icon>
          <div class="title-text">{{ items.meta.title }}</div>
          <div class="arrow" v-if="items.children">
            <svg-icon :iconClass="rightIcon"  class="arrowIcon" :style="{ 'transform': open ? 'rotate(90deg)' : 'rotate(0)' }"> </svg-icon>
          </div>
        </div>
        <div v-if="items.children" v-show="open" >
            <menuItem v-for="(item, index) in items.children" :items="item" :key="index" :nowPath="nowPath" :level="level + 1" ></menuItem>
        </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'menuItem',
  props: {
    items: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 1
    },
  },
  data () {
    return {
      open: false,
      rightIcon: 'arrow-right',
      downIcon: 'arrow-down',
      nowUrl: '',
    }
  },
  computed: {
    indent () {
      return {
        paddingLeft: `${this.level * 20}px`,
      };
    },
    nowPath: {
      get () {
        return this.$store.getters.nowPath;
      },
      set () { }
    }
  },
  methods: {
    openMenu (path) {
      setTimeout(() => {
        this.open = !this.open
      }, 10);

      this.nowPath = path
      if (path) {
        this.toUrl(path)
      }

    },
    toUrl (url) {
      if (url) {
        this.$store.commit('menu/changeValue', { 'key': 'nowPath', 'value': url })
        this.$router.push(url)
      }

    },
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 220px;
  position: relative;
  left: 0;
  top: 0;
}



.item {
  min-height: 40px;
  flex: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 20px;

  .svg-icon {
    font-size: 10px;
    margin-right: 16px;
    color: rgba(255, 255, 255, .8) !important
  }

  .title-text {
    flex: 1;
    font-size: 14px;
    color: rgba(255, 255, 255, .8) !important;
    font-family: -apple-system, Segoe UI, Roboto, Helvetica Neue, Microsoft YaHei, PingFang SC, \5fae\8f6f\96c5\9ed1, sans-serif, system-ui;
  }

  .arrow {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 6px;

    .arrowIcon {
      width: 12px;
      height: 18px;
    }
  }

}

.item:hover {
  background-color: rgba(255, 255, 255, .2);

}
</style>


// WEBPACK FOOTER //
// src/views/homePage/leftBox/menuItem.vue